import A from "./letter-a.png";
import B from "./letter-b.png";

export const LetterA = () => (
  <img src={A} alt="Letter A" style={{ width: "24px", height: "24px" }} />
);
export const LetterB = () => (
  <img src={B} alt="Letter B" style={{ width: "24px", height: "24px" }} />
);
